module.exports = __webpack_public_path__ + "img/image18.b61976be.jpg";